import { Plus, Minus } from "lucide-react";

const AddView = ({
  newFamilies,
  onCancel,
  onSave,
  onFamilyChange,
  onAddRow,
  onDeleteRow,
  onPhotoChange,
}) => {
  

  const handleColorPickerChange = (id, color) => {
    onFamilyChange(id, "familyCode", color);
  };

  const handleUrlChange = (id, url) => {
    onPhotoChange(id, url);
  };

  return (
    <>
      <div className="color-families__controls">
        <h2 className="color-families__subtitle">Adding color families</h2>
        <div style={{ marginLeft: "auto", display: "flex", gap: "16px" }}>
          <button className="color-families__cancel-btn" onClick={onCancel}>
            Cancel
          </button>
          <button className="color-families__save-btn" onClick={onSave}>
            Save items
          </button>
        </div>
      </div>

      <div className="color-families__table-wrapper">
        <table className="color-families__table">
          <thead>
            <tr>
              <th>Family name</th>
              <th>Family code & Pattern</th>
              <th>Colors in Family</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {newFamilies.map((family, index) => (
              <tr key={family.id}>
                <td>
                  <input
                    type="text"
                    className="color-families__input"
                    placeholder="Color family"
                    value={family.familyName}
                    onChange={(e) =>
                      onFamilyChange(family.id, "familyName", e.target.value)
                    }
                  />
                </td>
                <td>
                  <div className="color-families__code-input-wrapper">
                    <div className="color-families__color-picker-btn">
                      <input
                        type="color"
                        value={
                          family.familyCode.startsWith("#")
                            ? family.familyCode
                            : family.familyCode
                            ? `#${family.familyCode}`
                            : "#000000"
                        }
                        onChange={(e) =>
                          handleColorPickerChange(family.id, e.target.value)
                        }
                      />
                    </div>
                    <input
                      type="text"
                      className="color-families__code-input"
                      value={family.familyCode}
                      onChange={(e) =>
                        onFamilyChange(family.id, "familyCode", e.target.value)
                      }
                    />
                  </div>
                  <div className="color-families__url-input-section" style={{ marginTop: '8px' }}>
                    <input
                      type="url"
                      className="color-families__url-input"
                      placeholder="Enter image URL"
                      value={family.url || ''}
                      onChange={(e) => handleUrlChange(family.id, e.target.value)}
                      style={{
                        width: '100%',
                        padding: '6px 8px',
                        border: '1px solid #cbd5e1',
                        borderRadius: '4px',
                        fontSize: '12px'
                      }}
                    />
                    {family.url && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '6px' }}>
                        <div className="color-families__url-preview-inline" style={{
                          width: '36px',
                          height: '36px',
                          borderRadius: '4px',
                          overflow: 'hidden',
                          border: '1px solid #e2e8f0'
                        }}>
                          <img
                            src={family.url}
                            alt="Pattern"
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                          />
                        </div>
                        <span style={{ fontSize: '12px', color: '#64748b' }}>Image</span>
                      </div>
                    )}
                  </div>
                </td>
                <td>
                  <div style={{ position: "relative" }}>
                    <textarea
                      className="color-families__textarea"
                      placeholder="Add a list of mapping values here, separate them with comma. E.g. black, white"
                      value={family.colorsIncluded}
                      onChange={(e) =>
                        onFamilyChange(
                          family.id,
                          "colorsIncluded",
                          e.target.value
                        )
                      }
                    />
                  </div>
                </td>
                <td>
                  {index > 0 && (
                    <button
                      className="color-families__delete-btn"
                      onClick={() => onDeleteRow(family.id)}
                    >
                      <Minus />
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <button className="color-families__add-row-btn" onClick={onAddRow}>
        <Plus size={18} />
        Add row
      </button>
    </>
  );
};

export default AddView;
